import axios, { extractData, reportApi } from '@atheneum/api'
import { downloadFromUrl, exportDialogMessage, tokenStorage, stringifyYearMonth } from '@atheneum/api/dist/lib'
import _ from 'lodash'
import { computed, extendObservable } from 'mobx'
import queryString from 'query-string'

class RevenuesStore {
  constructor(staticData, atheneumOfficeStore) {
    extendObservable(this, {
      atheneumOfficeStore,
      staticData,
      loading: false,
      error: null,
      revenues: [],
      query: this.getEmptyQuery(),
      atheneumOffices: computed(() => {
        return [
          { id: '', name: 'All' },
          ...this.atheneumOfficeStore.atheneumOffices
        ]
      }),
      projectTypes: computed(() => {
        return [{ id: '', name: 'All' }, ...this.staticData.projectTypes]
      }),
      accountTypes: computed(() => {
        return [{ id: '', name: 'All' }, ...this.staticData.accountTypes]
      })
    })
  }

  getEmptyQuery() {
    return {
      date: stringifyYearMonth(Date.now()),
      apOffice: '',
      projectType: '',
      accountType: '',
      suggestion: null
    }
  }

  filterResults = () => {
    this.loading = true
    let url = `/api/project/revenues-report?date=${this.query.date}`
    if (this.query.apOffice) {
      url = url + `&apOffice=${this.query.apOffice}`
    }
    if (this.query.projectType) {
      url = url + `&projectType=${this.query.projectType}`
    }
    if (this.query.accountType) {
      url = url + `&accountType=${this.query.accountType}`
    }

    if (this.query.suggestion) {
      const { id, type } = this.query.suggestion
      const types = {
        account: 'account',
        project: 'project',
        employee: 'contact'
      }
      const queryParam = types[type]
      url = url + `&${queryParam}=${id}`
    }

    return axios
      .get(url)
      .then(res => {
        const responseData = extractData(res)
        if (responseData === undefined || responseData.length === 0) {
          this.revenues.replace(responseData)
        } else {
          const formattedData = responseData.map(res => {
            const country = this.staticData.names.countries[res.countryId]
            if (res.stillRequired < 0) {
              res.stillRequired = 0
            }
            return {
              ...res,
              country: country,
              stillRequired: res.stillRequired
            }
          })
          this.revenues.replace(formattedData)
        }
      })
      .catch(err => {
        this.error = err
      })
      .then(() => {
        this.loading = false
      })
  }

  async exportReport(props) {
    if (this.exportInProgress) return

    const params = _.omitBy(
      { ...this.query, export: props.export },
      val => !val
    )

    const token = tokenStorage.get()
    const queryParams = queryString.stringify({
      ..._.partial(_.omit, _, ['suggestion'])({
        ...params,
        ...(params.suggestion?.type === 'project' && {
          project: params.suggestion?.id
        }),
        ...(params.suggestion?.type === 'employee' && {
          contact: params.suggestion?.id
        }),
        ...(params.suggestion?.type === 'account' && {
          account: params.suggestion?.id
        })
      }),
      token
    })
    const filename = `project_revenues_${params.export}_report_${params.date}.xlsx`
    const response = await reportApi.exportProjectRevenuesReport(queryParams).catch(() =>
      alert('export failed')
    )
    const jobId = response?.jobId
    props.queueProcessorStore.trackJob(jobId, ({ url }) => {
      downloadFromUrl({ url: `${url}?token=${token}`, filename })
    })

    this.job = props.queueProcessorStore.jobs[jobId]

    if (this.job && this.job.loading) {
      this.exportInProgress = true
      setTimeout(() => {
        this.exportInProgress = false
      }, 1000)
    }
    await exportDialogMessage({ exportType: 'project revenues' })
  }

  autocompleteSuggestions = input => {
    if (!input) {
      return Promise.resolve([])
    }

    return axios.get(`/api/project/revenues-typeahead?q=${input}`).then(res => {
      const results = extractData(res)
      return results
    })
  }

  clearSearch() {
    this.query = this.getEmptyQuery()
    this.filterResults()
  }
}

export default RevenuesStore
